import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserRoles } from '../../shared/enum/userrole.enum';
import { BasePageComponent } from '../base.page';
import { localizationKeys } from './../../utils/localizationKeys';

@Component({
    selector: 'app-page-placeholder',
    templateUrl: './placeholder.page.html',
    styleUrls: ['./placeholder.page.scss'],
})
export class PlaceholderPage extends BasePageComponent implements OnInit {
    localizationKeys = localizationKeys;
    roles = [UserRoles.SUPER_ADMIN];
    constructor(injector: Injector, protected override router: Router) {
        super(injector);
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    hasReadPermission(): boolean {
        return true;
    }

    hasWritePermission(): boolean {
        return true;
    }
}
